import PropTypes from 'prop-types';
import { useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Divider, Stack, TextField } from '@mui/material';
import { ModalManager } from '@shared/components/providers/ModalProvider';
import { getLabel, hasInvalidChars } from '@shared/utils';
import { schemaCreateRole, schemaUpdateRole } from '@shared/utils/schemas/roleFormSchema';
import { useForm } from 'react-hook-form';
import CorrespondentSelector from './CorrespondentSelector';

const CreationRoleStep = ({ correspondentRole = {}, handleNext, onComplete }) => {
  const editMode = correspondentRole.role_id !== undefined;
  const [correspondentRoleData, setCorrespondentRoleData] = useState(correspondentRole || {});
  const [validate, setValidate] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm({
    resolver: yupResolver(editMode ? schemaUpdateRole(correspondentRole.role_name) : schemaCreateRole),
  });

  const onHandleNext = (data) => {
    setValidate(true);
    if (correspondentRoleData?.correspondent_type_ids?.length > 0) {
      const newData = { ...data, correspondent_type_ids: correspondentRoleData.correspondent_type_ids };
      onComplete(newData);
      handleNext();
    }
  };

  return (
    <form noValidate autoComplete="off" onSubmit={handleSubmit(onHandleNext)}>
      <Stack
        spacing={2}
        direction="column"
        useFlexGap
        sx={{ flexWrap: 'wrap', marginTop: '40px', marginBottom: '20px' }}>
        <TextField
          label={getLabel('roleName')}
          variant="outlined"
          defaultValue={correspondentRoleData['role_name']}
          error={!!errors?.role_name}
          helperText={errors?.role_name ? errors?.role_name?.message : ''}
          {...register('role_name', { required: true })}
          slotProps={{
            htmlInput: {
              maxLength: 40,
            },
          }}
          onChange={(event) => {
            const currentValue = event.target.value;
            const newValue = currentValue.replace(/^\s+/, '');
            if (hasInvalidChars(newValue)) {
              setError('role_name', {
                type: 'manual',
                message: 'Invalid characters',
              });
            }
          }}
        />
        <CorrespondentSelector
          defaultValue={correspondentRoleData['correspondent_type_ids']}
          onChange={(value) => {
            setCorrespondentRoleData({ ...correspondentRoleData, correspondent_type_ids: value });
          }}
          validate={validate}
        />
      </Stack>
      <Divider orientation="horizontal" flexItem sx={{ backgroundColor: '#7025c6', marginTop: '24px' }} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <Button
          variant="outlined"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => {
            ModalManager.closeModal();
          }}>
          {getLabel('cancel')}
        </Button>
        <Button variant="contained" sx={{ mt: 3, ml: 1 }} color="primary" type="submit">
          {getLabel('following')}
        </Button>
      </Box>
    </form>
  );
};

CreationRoleStep.propTypes = {
  correspondentRole: PropTypes.object,
  onComplete: PropTypes.func,
  handleNext: PropTypes.func,
};

export default CreationRoleStep;
